import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "w-full md:flex-1" }

import Sidebar from "@/components/Sidebar.vue";
import TopNav from "./components/TopNav.vue";
import MobileCategories from "./components/MobileCategories.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TopNav),
      _createVNode(MobileCategories),
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.path
      }))
    ])
  ]))
}
}

})